<template>
    <div class="table-container">
        <table class="table is-striped is-hoverable is-fullwidth">
            <thead>
                <th v-for="column in columns" :key="column.id" scope="col">
                    {{ column.text }}
                </th>
            </thead>
            <tbody>
                <template v-for="row in rows">
                    <Row :row="row" :columns="columns" :key="row.id" />
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import Row from "./table-column-types/TableRow.vue";

export default {
    name: "table-question",
    components: {
        Row,
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        columns() {
            return this.question.columns;
        },
        rows() {
            return this.question.answer.rows;
        },
    },
};
</script>